module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Road-Cone-db15228f05c438fbf4f1c26ea73ed4ed.svg";